import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import * as Fa from "react-icons/fa";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { format } from "date-fns";
import {
    createAPIAdvanceAdjEndpoint,
    Endpoint,
} from "../../Services/CustomerAdvAdj/CustomerAdvAdjService";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import storage from "../../Services/Storage";
import Loader from "../../Components/Loader";
const AdvanceAdjustmentDetails = () => {
    const [partynamesugg, setPartynamesugg] = useState([]);
    const [onchangepartyname, setOnchangepartyname] = useState([]);
    const [partyname, setPartyname] = useState([]);
    const [balanceAllocation, setBalanceAllocation] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [payableDocumentData, setPayableDocumentData] = useState([]);
    const [selectedPayableDocumentData, setSelectedPayableDocumentData] =
        useState([]);
    const [payablePopupShow, setPayablePopupShow] = useState(false);
    const [receivblePopupShow, setReceivblePopupShow] = useState(false);
    const [payableAllGridData, setPayableAllGridData] = useState([]);
    const [receivableDocumentData, setReceivableDocumentData] = useState([]);
    const [selectedreceivableDocumentData, setSelectedreceivableDocumentData] =
        useState([]);
    const [receiveableDocumentGridData, setReceiveableDocumentGridData] =
        useState([]);
    const [payableIsdata, setPayableIsdata] = useState(false);
    const [payableLoading, setPayableLoading] = useState(false);
    const [receiveLoading, setReceiveLoading] = useState(false);
    const [savebtnVisible, setSavebtnVisible] = useState(false);
    const [saveLoader, setSaveLoader] = useState(false);
    const [viewData, setViewData] = useState(false);
    const [viewDtDetailPay, setviewDtDetailPay] = useState([]);
    const [viewDtDetailRecv, setviewDtDetailRecv] = useState([]);
    const [currentDate, setCurrentDate] = useState();
    const [adjdt, setAdjdt] = useState();
    const [surePopup, setSurePopup] = useState(false);
    const [showCancelbtn, setShowCancelbtn] = useState(false);
    const [adjustmentno, setAdjustmentno] = useState();
    const [viewDtdata, setViewDtdata] = useState();
    const navlink = useNavigate();
    const [searchparam] = useSearchParams();
    let partyid = searchparam.get("partyid");
    let first_entered = searchparam.get("dt");
    let Adjon = searchparam.get("adjno");
    const auth = storage.getLocal("user");

    useEffect(() => {
        const todaydt = format(new Date(), "yyyy-MM-dd");
        setCurrentDate(todaydt);
        populatePartyData();
        if (partyid != null) {
            populateViewData(partyid);
            setViewData(true);
        }
    }, []);

    const populatePartyData = () => {
        createAPIAdvanceAdjEndpoint()
            .get(`${Endpoint.GetPartyName}?CompId=${auth.CompId}`)
            .then((response) => {
                // console.log("responseData", response.data);
                // setPartynamesugg(response.data.Data);
                // console.log("responseData", response.data);
                if(response.data.Status==="Warning"){
                    setPartynamesugg([]);
                }
                else{
                    setPartynamesugg(response.data.Data);
                }
            })
            .catch((error) => {console.log(error);
            });
        // setPartynamesugg(party);
    };

    const populateViewData = (partyid) => {
        setSaveLoader(true);
        createAPIAdvanceAdjEndpoint()
            .get(
                `${Endpoint.ViewAdvanceAdjustment}?ADJ_NO=${Adjon}&ADJ_Date=${first_entered}&PartyId=${encodeURIComponent(partyid)}&CompId=${auth.CompId}`
            )
            .then((response) => {
                // console.log("viewresponseData", response.data);
                setviewDtDetailPay(response.data.DtDetailPay);
                setviewDtDetailRecv(response.data.DtDetailRecv);
                setOnchangepartyname(response.data.DtHeader[0].PARTY_NAME);
                setAdjustmentno(response.data.DtHeader[0].ADJ_NO);
                setViewDtdata(response.data.DtHeader[0].MASK_FIRST_ENTERED_ON);
                setBalanceAllocation(response.data.Balalce_Allocation);
                setTotalAmount(response.data.Advance_AMT);
                if (response.data.DtHeader[0].STATUS === "Cancel") {
                    setShowCancelbtn(true);
                }
                setSaveLoader(false);
            })
            .catch(() => {
                setSaveLoader(false);
            });
    };

    const searchEmployee = (e) => {
        setTimeout(() => {
            let _filteredemployee;
            if (!e.query.trim().length) {
                _filteredemployee = [...partynamesugg];
            } else {
                _filteredemployee = partynamesugg.filter((employee) => {
                    return (
                        employee.CUSTOMER_CODE.toLowerCase().includes(
                            e.query.toLowerCase()
                        ) ||
                        employee.CUSTOMER_NAME.toLowerCase().includes(e.query.toLowerCase())
                    );
                });
            }

            setPartyname(_filteredemployee);
        }, 250);
    };

    const employeeTemplate = (employee) => {
        return (
            <>
                {employee.CUSTOMER_CODE} - {employee.CUSTOMER_NAME}
            </>
        );
    };

    const receivableDocumentAmt = () => {
        if (Object.keys(onchangepartyname).length === 0) {
            toast.warn("Please select Customer Name", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        } else if (!payableIsdata) {
            toast.warn("Please select payable document(s)", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        } else {
            receivableAmountGrid(onchangepartyname.MASK_PARTY_ID);
        }
        // console.log("setOnchangepartyname", onchangepartyname);
    };

    const payableDocumntAmt = () => {
        if (Object.keys(onchangepartyname).length === 0) {
            toast.warn("Please select Customer Name", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        } else {
            setPayableDocumentData([]);
            paybleAmountGridData(onchangepartyname.MASK_PARTY_ID);
        }
    };

    const paybleAmountGridData = (partyId) => {
        setPayableLoading(true);
        createAPIAdvanceAdjEndpoint()
            .get(
                `${Endpoint.GetPayableDocument}?PartyId=${encodeURIComponent(partyId)}&CompId=${auth.CompId}`
            )
            .then((response) => {
                // console.log("responseData", response.data);
                if (response.data.Status === "Warning") {
                    setPayableDocumentData([]);
                    setPayableLoading(false);
                    // setPayablePopupShow(true);
                } else {
                    setPayableDocumentData(response.data.Data);
                    setPayableLoading(false);
                    // setPayablePopupShow(true);
                }
                // setPayableDocumentData(response.data.Data);
            })
            .catch(() => {
                setPayableLoading(false);
            });
        setPayablePopupShow(true);
        // setPayableDocumentData(dataArray);
    };

    const receivableAmountGrid = (partyId) => {
        setReceiveLoading(true);
        createAPIAdvanceAdjEndpoint()
            .get(`${Endpoint.GetReceivableDocument}?PartyId=${encodeURIComponent(partyId)}`)
            .then((response) => {
                // console.log("responseData", response.data);
                if (response.data.Status === "Warning") {
                    setReceivableDocumentData([]);
                    setReceiveLoading(false);
                } else {
                    setReceivableDocumentData(response.data.Data);
                    setReceiveLoading(false);
                }
            })
            .catch(() => {
                setReceiveLoading(false);
            });
        // setReceivableDocumentData(dataArray1);
        setReceivblePopupShow(true);
    };
    const handleOkPayable = () => {
        let balanceamt = selectedPayableDocumentData.reduce((prev, curr) => {
            return Number(prev) + Number(curr.ADVANCE_AMT);
        }, 0);
        // console.log("balanceamt", balanceamt);
        setBalanceAllocation(Number(balanceamt).toFixed(2));
        setTotalAmount(Number(balanceamt).toFixed(2));
        setPayableAllGridData(selectedPayableDocumentData);
        // console.log("selectedPayableDocumentData", selectedPayableDocumentData);
        setPayablePopupShow(false);
        if (selectedPayableDocumentData.length > 0) {
            setPayableIsdata(true);
        } else {
            setPayableIsdata(false);
        }
    };

    const handleOkReceivable = () => {
        // debugger;
        let updatedselectedreceivableDocumentData = [];
        updatedselectedreceivableDocumentData = selectedreceivableDocumentData.map(
            (obj) => ({
                ...obj,
                amount: 0,
            })
        );
        // console.log(
        //     "updatedselectedreceivableDocumentData",
        //     updatedselectedreceivableDocumentData
        // );
        let remainingAmount = totalAmount;
        updatedselectedreceivableDocumentData.forEach((item) => {
            if (remainingAmount >= Number(item.PAYABLE_AMOUNT)) {
                item.amount = Number(item.PAYABLE_AMOUNT);
                remainingAmount -= Number(item.PAYABLE_AMOUNT);
            } else {
                item.amount = Number(remainingAmount).toFixed(2);
                remainingAmount = 0;
            }
        });

        let reminingBalanceAllocation =
            updatedselectedreceivableDocumentData.reduce((prev, curr) => {
                return Number(prev) + Number(curr.amount);
            }, 0);
        setBalanceAllocation(
            Number(totalAmount - reminingBalanceAllocation).toFixed(2)
        );

        if (
            payableAllGridData.length > 0 &&
            updatedselectedreceivableDocumentData.length > 0
        ) {
            setSavebtnVisible(true);
        } else {
            setSavebtnVisible(false);
        }

        // console.log("totalAmount", totalAmount);
        // console.log(
        //     "updatedselectedreceivableDocumentData",
        //     updatedselectedreceivableDocumentData
        // );
        setReceiveableDocumentGridData(updatedselectedreceivableDocumentData);
        // console.log(
        //     "selectedreceivableDocumentData",
        //     selectedreceivableDocumentData
        // );
        // console.log("payableAllGridData", payableAllGridData);
        // console.log("receiveableDocumentGridData", receiveableDocumentGridData);
        setReceivblePopupShow(false);
    };
    const handleClickPayableCancel = () => {
        setPayablePopupShow(false);
    };
    const handleClickReceiveCancel = () => {
        setReceivblePopupShow(false);
    };

    const onAmountChange = (val, rowData) => {
        const updatedData = receiveableDocumentGridData.map((item) => {
            if (item.DOCUMENT_NO === rowData.DOCUMENT_NO) {
                return { ...item, amount: val };
            }
            return item;
        });
        setReceiveableDocumentGridData(updatedData);
    };

    useEffect(() => {
        // console.log("hello",receiveableDocumentGridData);
        let reminingBalanceAllocation = receiveableDocumentGridData.reduce(
            (prev, curr) => {
                return Number(prev) + Number(curr.amount);
            },
            0
        );
        setBalanceAllocation(
            Number(totalAmount - reminingBalanceAllocation).toFixed(2)
        );
    }, receiveableDocumentGridData);

    const saveDocumentdata = () => {
        // console.log("receiveableDocumentGridData", receiveableDocumentGridData);
        // console.log("payableAllGridData", payableAllGridData);
        // console.log("balanceAllocation", balanceAllocation);
        // console.log("totalAmount", totalAmount);

        let paydetails = payableAllGridData.map((val) => ({
            masK_RCVD_ID: val.MASK_RCVD_ID,
            documenT_NO: val.DOCUMENT_NO,
            documenT_DATE: val.DOCUMENT_DATE,
            modE_TYPE: val.MODE_,
            chQ_NO: val.CHQ_NO,
            advancE_AMT: val.ADVANCE_AMT.toString(),
            exchangE_RATE: val.EXCHANGE_RATE,
            masK_ACCT_ID: val.MASK_ACCT_ID,
            masK_STATUS: val.MASK_STATUS,
        }));
        let receivedetails = receiveableDocumentGridData.map((val) => ({
            documenT_NO: val.DOCUMENT_NO,
            documenT_DATE: val.DOCUMENT_DATE,
            masK_DOCUMENT_AMT: val.MASK_DOCUMENT_AMT.toString(),
            payablE_AMOUNT: val.PAYABLE_AMOUNT.toString(),
            amount: val.amount.toString(),
            masK_DOC_TYPE: val.MASK_DOC_TYPE,
            adJ_AMT: "",
            masK_DOC_SR_NO: val.PAYTERM_SERIAL_NUMBAR,
        }));

        const checkAmountVsPayable = (invoice) => {
            let amount = parseFloat(invoice.amount);
            let payableAmount = parseFloat(invoice.PAYABLE_AMOUNT);
            if (amount > payableAmount) {
                return true;
            }
            return false;
        };
        let isAmountGreaterThanPayable = false;
        let itCantBeZero = false;
        if (receiveableDocumentGridData.length > 0) {
            receiveableDocumentGridData.forEach((invoice) => {
                if (checkAmountVsPayable(invoice)) {
                    isAmountGreaterThanPayable = true;
                }
                return null;
            });
            receiveableDocumentGridData.forEach((item)=>{
                if(Number(item.amount)==0){
                    itCantBeZero=true;
                }
                return null;
            });

        }


        let receive = receiveableDocumentGridData.reduce((prev, curr) => {
            return Number(prev) + Number(curr.amount);
        }, 0);
        let payble = payableAllGridData.reduce((prev, curr) => {
            return Number(prev) + Number(curr.MASK_DOCUMENT_AMT);
        }, 0);




        if (isAmountGreaterThanPayable) {
            toast.warn(
                "Adjusted Amount is greater than payable amount for Outstanding Receivables",
                {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 4000,
                }
            );
        }
        else if(itCantBeZero){
            toast.warn(
                "Adjusted Amount can't be 0 or empty",
                {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 4000,
                }
            );
        }
        else if (balanceAllocation < 0) {
            toast.warn("Balance for Allocation can't be negative", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        }
        
        else if ( receive>payble ) {
            toast.warn("Receivable can't be greater than Payable", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        }
        else {
            let payload = {
                userId: auth.UserId,
                compId: auth.CompId,
                partyId: onchangepartyname.MASK_PARTY_ID,
                balAllocAmt: balanceAllocation,
                totalDocAmt: totalAmount,
                listPayDetail: paydetails,
                listRevcDetail: receivedetails,
            };

            // console.log("payload", payload);
            console.log("adjdt", adjdt);
            // return;
            setSaveLoader(true);
            createAPIAdvanceAdjEndpoint()
                .post(`${Endpoint.SaveAdvanceAdjustment}`, JSON.stringify(payload), {
                    headers: { "Content-Type": "application/json" },
                })
                .then((res) => {
                    // console.log("Ab000", res.data);

                    if (res.data.Status === "Success") {
                        toast.success(`${res.data.Message}`, {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 3000,
                        });
                        setSaveLoader(false);
                        navlink("/creditmanagement/customeradvanceadjustment");
                    } else {
                        console.log(res.data);
                        toast.warn(`${res.data.Message}`, {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 3000,
                        });
                        setSaveLoader(false);
                    }
                })
                .catch(() => {
                    toast.error("Something Went Wrong. Please Contact Helpdesk.", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                    setSaveLoader(false);
                    navlink("/creditmanagement/customeradvanceadjustment");
                });
        }
    };
    const renderAction = (rowData) => {
        
        return (
            <>
                {Number(rowData.amount)==0 &&<div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Cancel"
                    >
                        <button
                            className="grid-icon"
                            onClick={() => {
                                cancelrecv(rowData.DOCUMENT_NO);
                            }}
                        >
                            <Fa.FaTimes className="cancel" />
                        </button>
                    </div>
                </div>}
            </>
        );
    };


    const cancelrecv = (documentnumber)=>{
        // console.log("documentnumber",documentnumber);
        // console.log("documentnumber",receiveableDocumentGridData);
        let removedreceved =  receiveableDocumentGridData.filter((item)=>{
            return item.DOCUMENT_NO !== documentnumber;
        });

        setReceiveableDocumentGridData(removedreceved);
    };

    const cancelClickbtn = () => {
        setSaveLoader(true);
        createAPIAdvanceAdjEndpoint()
            .get(`${Endpoint.CancelAdvAdj}?CompId=${auth.CompId}&UserId=${auth.UserId}&AdjNo=${Adjon}&Adjdate=${first_entered}&PartyId=${encodeURIComponent(partyid)}`)
            .then((response) => {
                // console.log("responseData", response.data);
                if (response.data.Status === "Success") {
                    toast.success("Customer Advance Adjustment Cancelled Successfully", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                    setShowCancelbtn(true);
                }
                else {
                    toast.warn("Oops..Something Went Wrong", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                    setShowCancelbtn(false);
                }
                setSaveLoader(false);
                setSurePopup(false);
            })
            .catch((ex) => {
                toast.error(ex?.response?.data?.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                setSaveLoader(false);
                setSurePopup(false);
            });
    };

    if (saveLoader) {
        return (
            <>
                <Loader />
            </>
        );
    } else {
        return (
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mx-1">
                                <li className="breadcrumb-item">
                                    <Link to="/creditmanagement/customeradvanceadjustment">Customer Advance Adjustment</Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Details
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end">
                            <Link to="/creditmanagement/customeradvanceadjustment">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                                    Records
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">
                                    Customer Name <span className="mandatory">*</span>
                                </label>
                                <div className="d-block">
                                    <AutoComplete
                                        field="CUSTOMER_NAME"
                                        value={onchangepartyname}
                                        suggestions={partyname}
                                        completeMethod={searchEmployee}
                                        onChange={(e) => {
                                            setOnchangepartyname(e.target.value);
                                            setPayableDocumentData([]);
                                            setSelectedPayableDocumentData([]);
                                            setPayableAllGridData([]);
                                            setReceivableDocumentData([]);
                                            setSelectedreceivableDocumentData([]);
                                            setReceiveableDocumentGridData([]);
                                        }}
                                        dropdown={true}
                                        forceSelection={true}
                                        itemTemplate={employeeTemplate}
                                        emptyMessage="No Customer Name found."
                                        showEmptyMessage
                                        disabled={viewData}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">
                                    Adjustment No. <span className="mandatory">*</span>
                                </label>
                                <InputText className="form-control" value={adjustmentno} disabled />
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">
                                    Adjustment Date <span className="mandatory">*</span>
                                </label>
                                {/* <InputText className="form-control" type="date" disabled /> */}
                                {!viewData && <input
                                    type="date"
                                    className="form-control"
                                    defaultValue={currentDate}
                                    max={currentDate}
                                    min="2010-01-01"
                                    name="date-field"
                                    onChange={(e) => {
                                        setAdjdt(e.target.value);
                                    }}
                                />}
                                {viewData && <InputText className="form-control" value={viewDtdata} disabled />}
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">Balance for Allocation</label>
                                <InputText
                                    value={balanceAllocation}
                                    className="form-control"
                                    disabled
                                />
                            </div>
                            {viewData ? <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">Advance Amount</label>
                                <InputText
                                    value={Number(totalAmount).toFixed(2)}
                                    className="form-control"
                                    disabled
                                />
                            </div> :
                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                    <label className="form-label">Total Amount</label>
                                    <InputText
                                        value={Number(totalAmount).toFixed(2)}
                                        className="form-control"
                                        disabled
                                    />
                                </div>}

                            {!viewData && (
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="float-end mt-2">
                                        {savebtnVisible && (
                                            <button
                                                type="button"
                                                className="btn btn-primary me-3"
                                                onClick={saveDocumentdata}
                                            >
                                                Save
                                            </button>
                                        )}
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary me-3"
                                            onClick={receivableDocumentAmt}
                                        >
                                            Receivable Document
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={payableDocumntAmt}
                                        >
                                            Payable Document
                                        </button>
                                    </div>
                                </div>
                            )}

                            {viewData && (
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="float-end mt-2">
                                        <button
                                            type="button"
                                            className="btn btn-cancel-red"
                                            onClick={() => {
                                                setSurePopup(true);
                                            }}
                                            disabled={showCancelbtn}
                                        >
                                            Cancel Payment
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </form>
                </section>
                {viewData ? (
                    <section className="">
                        <h3>Payable Records</h3>
                        <div className="DataTable pb-4 pt-1">
                            <DataTable
                                value={viewDtDetailPay}
                                paginator
                                rows={10}
                                // showGridlines
                                stripedRows
                                emptyMessage="No Records found to display."
                                tableStyle={{ minWidth: "60rem" }}
                            >
                                <Column field="DOCUMENT_NO" header="Document Number"></Column>
                                <Column field="DOCUMENT_DATE" header="Document Date"></Column>
                                <Column
                                    field="MODE_"
                                    header="Mode"
                                ></Column>
                                <Column
                                    field="CHQ_NO"
                                    header="Cheque/Draft No."
                                ></Column>
                                <Column
                                    field="ADVANCE_AMT"
                                    header="Advance Amount"
                                ></Column>

                            </DataTable>
                        </div>
                        <h3>Receivable Records</h3>
                        <div className="DataTable pb-4 pt-1">
                            <DataTable
                                value={viewDtDetailRecv}
                                paginator
                                rows={10}
                                // showGridlines
                                stripedRows
                                emptyMessage="No Records found to display"
                                tableStyle={{ minWidth: "60rem" }}
                            >
                                <Column field="DOCUMENT_NO" header="Document Number"></Column>
                                <Column field="DOCUMENT_DATE" header="Document Date"></Column>
                                <Column
                                    field="ADJ_DOC_TYPE"
                                    header="Document Type"
                                ></Column>
                                <Column
                                    field="ADJ_AMT"
                                    header="Adjusted Amount"
                                ></Column>
                                
                            </DataTable>
                        </div>
                    </section>
                ) : (
                    <section className="">
                        <h3>Payable Records</h3>
                        <div className="DataTable pb-4 pt-1">
                            {payableLoading ? (
                                <Loader />
                            ) : (
                                <DataTable
                                    value={payableAllGridData}
                                    paginator
                                    rows={10}
                                    // showGridlines
                                    stripedRows
                                    emptyMessage="No Records found to display."
                                    //   rowsPerPageOptions={[10, 25, 50]}
                                    tableStyle={{ minWidth: "60rem" }}
                                >
                                    <Column
                                        field="DOCUMENT_NO"
                                        header="Document Number"
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="DOCUMENT_DATE"
                                        header="Document Date"
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="MODE_"
                                        header="Mode"
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="CHQ_NO"
                                        header="Cheque/Draft No."
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="ADVANCE_AMT"
                                        header="Advance Amount"
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                        body={(rowData) => Number(rowData.ADVANCE_AMT).toFixed(2)}
                                    ></Column>
                                    {/* <Column field={renderAction} header="Action" /> */}
                                </DataTable>
                            )}
                        </div>
                        <h3>Receivable Records</h3>
                        <div className="DataTable pb-4 pt-1">
                            {receiveLoading ? (
                                <Loader />
                            ) : (
                                <DataTable
                                    value={receiveableDocumentGridData}
                                    paginator
                                    rows={10}
                                    // showGridlines
                                    stripedRows
                                    emptyMessage="No Records found to display"
                                    //   rowsPerPageOptions={[10, 25, 50]}
                                    tableStyle={{ minWidth: "60rem" }}
                                >
                                    <Column
                                        field="DOCUMENT_NO"
                                        header="Document Number"
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="DOCUMENT_DATE"
                                        header="Document Date"
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="MASK_DOCUMENT_AMT"
                                        header="Document Amount"
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="PAYABLE_AMOUNT"
                                        header="Outstanding Payables"
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="amount"
                                        header="Amount"
                                        body={(rowData) => (
                                            <InputText
                                                value={rowData.amount}
                                                // onChange={(e) => onAmountChange(e, rowData)}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    const regex = /^\d*\.?\d{0,2}$/;
                                                    if (regex.test(inputValue) || inputValue === "") {
                                                        onAmountChange(inputValue, rowData);
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                    <Column body={renderAction} header="Action "></Column>
                                </DataTable>
                            )}
                        </div>
                    </section>
                )}

                <div className="">
                    <Dialog
                        header="Payable Records"
                        visible={payablePopupShow}
                        style={{ width: "80vw" }}
                        onHide={() => setPayablePopupShow(false)}
                        closable={false}
                        resizable={false}
                        draggable={false}
                    >
                        <div className="col-md-12 col-lg-12 col-sm-12">
                            <div className="DataTable mb-3">
                                <DataTable
                                    value={payableDocumentData}
                                    paginator
                                    rows={10}
                                    filterDisplay="row"
                                    // showGridlines
                                    stripedRows
                                    selectionMode="checkbox"
                                    selection={selectedPayableDocumentData}
                                    rowsPerPageOptions={[10, 25, 50]}
                                    scrollHeight="80vh"
                                    showSelectAll={false}
                                    onSelectionChange={(e) => {
                                        setSelectedPayableDocumentData(e.value);
                                    }}
                                    emptyMessage="No Records found to display"
                                    tableStyle={{ minWidth: "20rem" }}
                                >
                                    <Column
                                        selectionMode="multiple"
                                        headerStyle={{ width: "3rem" }}
                                    ></Column>
                                    <Column
                                        field="DOCUMENT_NO"
                                        header="Document Number"
                                        style={{ minWidth: "8rem" }}
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="DOCUMENT_DATE"
                                        header="Document Date"
                                        style={{ minWidth: "12rem" }}
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="MODE_"
                                        header="Mode"
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                        style={{ minWidth: "12rem" }}
                                    ></Column>
                                    <Column
                                        field="CHQ_NO"
                                        header="Cheque/Draft No."
                                        style={{ minWidth: "12rem" }}
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="ADVANCE_AMT"
                                        header="Advance Amount"
                                        style={{ minWidth: "12rem" }}
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                        body={(rowData) => Number(rowData.ADVANCE_AMT).toFixed(2)}
                                    ></Column>
                                </DataTable>
                            </div>
                        </div>
                        <div className="float-end">
                            <button
                                type="button"
                                className="btn btn-primary me-3"
                                onClick={handleOkPayable}
                            >
                                OK
                            </button>
                            <button
                                type="button"
                                className="btn btn-cancel-red"
                                onClick={handleClickPayableCancel}
                            >
                                Cancel
                            </button>
                        </div>
                    </Dialog>
                </div>
                <div className="">
                    <Dialog
                        header="Receivable Records"
                        visible={receivblePopupShow}
                        style={{ width: "80vw" }}
                        onHide={() => setReceivblePopupShow(false)}
                        closable={false}
                        resizable={false}
                        draggable={false}
                    >
                        <div className="col-md-12 col-lg-12 col-sm-12">
                            <div className="DataTable mb-3">
                                <DataTable
                                    value={receivableDocumentData}
                                    paginator
                                    rows={10}
                                    filterDisplay="row"
                                    // showGridlines
                                    stripedRows
                                    selectionMode="checkbox"
                                    selection={selectedreceivableDocumentData}
                                    // rowsPerPageOptions={[10, 25, 50]}
                                    scrollHeight="80vh"
                                    showSelectAll={false}
                                    onSelectionChange={(e) => {
                                        setSelectedreceivableDocumentData(e.value);
                                    }}
                                    emptyMessage="No Records found to display"
                                    tableStyle={{ minWidth: "20rem" }}
                                >
                                    <Column
                                        selectionMode="multiple"
                                        headerStyle={{ width: "3rem" }}
                                    ></Column>
                                    <Column
                                        field="DOCUMENT_NO"
                                        header="Document Number"
                                        style={{ minWidth: "8rem" }}
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="DOCUMENT_DATE"
                                        header="Document Date"
                                        style={{ minWidth: "12rem" }}
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    {/* <Column
                  field="REAS_DESC"
                  header="Reason"
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder="Search Here..."
                  style={{ minWidth: "12rem" }}
                ></Column> */}
                                    <Column
                                        field="PAYABLE_AMOUNT"
                                        header="Outstanding Payables"
                                        style={{ minWidth: "12rem" }}
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                </DataTable>
                            </div>
                        </div>
                        <div className="float-end">
                            <button
                                type="button"
                                className="btn btn-primary me-3"
                                onClick={handleOkReceivable}
                            >
                                OK
                            </button>
                            <button
                                type="button"
                                className="btn btn-cancel-red"
                                onClick={handleClickReceiveCancel}
                            >
                                Cancel
                            </button>
                        </div>
                    </Dialog>
                </div>
                <Dialog
                    header="Information"
                    visible={surePopup}
                    style={{ width: "50vw" }}
                    // onHide={() => setSurePopup(false)}
                    closable={false}
                    resizable={false}
                    draggable={false}
                >
                    <div>
                        <p className="mb-0">
                            Are you sure to Delete the Customer Advance Adjustment ?
                        </p>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="float-end">
                            <button
                                type="button"
                                className="btn btn-primary me-3"
                                onClick={cancelClickbtn}
                            >
                                OK
                            </button>
                            <button
                                type="button"
                                className="btn btn-cancel-red"
                                onClick={() => {
                                    setSurePopup(false);
                                }}
                            >
                                Cancel 
                            </button>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
};

export default AdvanceAdjustmentDetails;
